import React from 'react';
import { MetaTags } from '../../components/meta-tags';
import { Header } from '../../components/layout/page-header';
import { CUSTOM_PAGE_TYPE } from '../../helpers/constants';
import { sanitizeString } from '../../helpers/sanitize';
import { getCustomPageTemplateConfiguration } from '../../helpers/custom-page/configuration';
import styles from '../../styles/templates/custom-page/custom-template.module.scss';
import { Template } from '../../components/template';
import { CustomPageTemplates as CustomTemplateWrapper } from '../../widgets/components/templates';
import { Spacer } from '../../components/layout/spacers';
import { Footer, LegalFooter } from '../../components/layout/page-footer';
import { CustomPageSection } from './sections';

export const CustomPageDefault = React.memo(props => {
  const { currentPage, sections, widgets } = props;
  const { widget, meta, content, type, statusMapping, legalFooter } = currentPage;
  const isVisibleLegalText =
    legalFooter?.display && (type === CUSTOM_PAGE_TYPE.START_PAGE || type === CUSTOM_PAGE_TYPE.RESULT_PAGE);

  const templateConfig = getCustomPageTemplateConfiguration(type);
  const { pageHeader } = templateConfig;

  //TODO: check with BE the `headerSubBlockName`
  return (
    <>
      <MetaTags tags={meta} />
      <Header
        name={widget.name}
        heading={sanitizeString(content.title)}
        subheading={sanitizeString(content.subHeading)}
        category={content.identifier}
        subBlockName={content.headerSubBlockName}
        className={styles.header}
        image={content.headerImage}
        type={pageHeader?.type}
        headerButtons={pageHeader?.headerButtons}
        backgroundPosition={pageHeader?.backgroundPosition}
      />
      <Template className={styles.body}>
        <CustomTemplateWrapper name={widget.name} widgets={widgets} page={currentPage} sections={sections}>
          <Spacer type='top' />
          {sections.map(([name, data], index) => (
            <React.Fragment key={name}>
              {index > 0 && <Spacer type='component' />}
              <CustomPageSection
                id={name}
                name={name}
                data={data}
                type={type}
                widgets={widgets}
                activity={statusMapping.activity}
              />
            </React.Fragment>
          ))}
          <Spacer type='bottom' />
        </CustomTemplateWrapper>
      </Template>
      {isVisibleLegalText ? <LegalFooter className={styles['footer-legal']} html={legalFooter?.text} /> : null}
      <Footer pageType='custom' />
    </>
  );
});
